import axios from 'axios';

export default {
    get() {
        let url = window.apiUrl + '/workshops'
        
        // url += '?cache=workshops';
        
        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

};



// WEBPACK FOOTER //
// ./src/services/workshops/index.js